import { handleError, handleResponse, MyAxios, priorityHandleError } from '@services/SettingAxios';
import { SummaryModel } from '@models/Reviews/SummaryModel';
import { FilterModel } from '@models/Reviews/FilterModel';
import { ReviewModel, ReviewGroupedModel } from '@app/Types/Reviews';
import { PagedModel } from '@app/Types/Catalog';
import { TypePromiseBrands, TypePromiseGetBrand, TypePromiseModel, TypePromiseModels } from '../ServiceTire/TypePromise';

class ServiceReviewsTyres {
  async getSummary(brandId, season, modelId = null) {
    const qseason = season !== null ? season : '';
    const qbrandId = brandId !== null ? brandId : '';
    const qmodelId = modelId !== null ? modelId : '';

    return MyAxios.get<SummaryModel>(`/api/reviews/tyres/summary?brandId=${qbrandId}&season=${qseason}&modelId=${qmodelId}`)
      .then(handleResponse)
      .catch(priorityHandleError);
  }

  async getList(filter: FilterModel): Promise<PagedModel<ReviewModel>> {
    return MyAxios.post('/api/reviews/tyres/list', { ...filter })
      .then(handleResponse)
      .catch(priorityHandleError);
  }

  async getGrouped(filter: FilterModel): Promise<ReviewGroupedModel[]> {
    return MyAxios.post('/api/reviews/tyres/grouped', { filter }).then(handleResponse).catch(priorityHandleError);
  }

  async getBrands(regionId: number): Promise<TypePromiseBrands> {
    return MyAxios.get(`/api/reviews/tyres/brands?regionId=${regionId}`).then(handleResponse).catch(priorityHandleError);
  }

  async getBrand(code: string): Promise<TypePromiseGetBrand> {
    return MyAxios.get(`/api/reviews/tyres/${code}/`).then(handleResponse).catch(handleError);
  }

  async getModels(filter): Promise<TypePromiseModels> {
    return MyAxios.post('/api/reviews/tyres/models', filter).then(handleResponse).catch(handleError);
  }

  async getModel<T = TypePromiseModel>(brandCode: string, code: string, regionId?: number): Promise<T> {
    return MyAxios.get(`/api/reviews/tyres/${brandCode}/${code}/?region=${regionId}`).then(handleResponse).catch(handleError);
  }
}

const serviceReviewsTyresInstance = new ServiceReviewsTyres();

export default serviceReviewsTyresInstance;
